module.exports = __webpack_public_path__ + "static/media/politico.com_2016-election_results_map_president_plot.62d85b92.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/politico.com_2016-election_results_map_president_plot.png
// module id = 415
// module chunks = 0